import { getElementPositionInContainer } from '../helpers/functions';
const initTabs = () => {
  const tabEl = document.querySelectorAll('button[data-bs-toggle="tab"]');
  const moveActiveTab = ($el, $tabNav) => {
    const width = $el.offsetWidth;
    const {
      left
    } = getElementPositionInContainer($el, $tabNav);
    $tabNav.style.setProperty('--bs-tab-active-width', `${width}px`);
    $tabNav.style.setProperty('--bs-tab-active-position', `${left}px`);
  };
  tabEl.forEach($el => {
    const $tabNav = $el.closest('.nav-tabs');
    if ($el.classList.contains('active')) moveActiveTab($el, $tabNav);
    $el.addEventListener('shown.bs.tab', () => {
      moveActiveTab($el, $tabNav);
    });
  });
};
export default initTabs;